var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-scrollbar-helper",style:({
    '--helper-bottom': `${_vm.bottom}px`,
    '--helper-left': `${_vm.left}px`,
    '--scrollbar-width': `${_vm.headerWidth}px`,
    '--scrollbar-max-width': `${_vm.scrollbarWidth}px`
  }),on:{"scroll":_vm.onScroll,"mousedown":function($event){_vm.grabHelper = true},"mouseup":function($event){_vm.grabHelper = false}}},[_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }